//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';
import { isMobile as detectMobileDevice } from '@motionelements/core/src/helpers/browser.js';
import { faPlay } from '@fortawesome/pro-solid-svg-icons';

export default {
  name: 'video-player-gallery-item',
  mixins: [featureFlagMixin],
  inject: {
    isPopUp: {
      default: false,
    },
  },
  props: {
    // previews: Object,
    element: Object,
  },
  data() {
    return {
      faPlay,
      player: {},
      nativePreviewPlaying: false,
      nativePreviewVideoEl: null,
      fullPageSplashDismissed: false,
    };
  },
  computed: {
    ...mapState({
      isMobile: state => state.browser.isMobile,
    }),
    isMobileDevice() {
      return this.isMobile ?? detectMobileDevice();
    },
    posterUrl() {
      return _.get(this.element, 'previews.jpg.url')
        || _.get(this.element, 'thumbnail.url')
        || _.get(this.element, 'thumbnails.jpg.url')
        || '';
    },
    showMobileSplash() {
      if (!this.shouldPrimeMobilePreview) {
        return false;
      }
      if (this.isFullPageNativePreview) {
        return !this.fullPageSplashDismissed;
      }
      return !this.nativePreviewPlaying;
    },
    showNativeVideoControls() {
      return this.useNativeControls
        || (this.isFullPageNativePreview && this.fullPageSplashDismissed);
    },
    playerContainerStyle() {
      if (this.useNativeVideoPreview && this.showNativeVideoControls) {
        return null;
      }
      if (!this.posterUrl) {
        return null;
      }
      return {
        backgroundImage: `url(${this.posterUrl})`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      };
    },
    useNativeVideoPreview() {
      return this.isFeatureEnabled('product_preview_native_video');
    },
    useNativeControls() {
      return this.isPopUp && this.useNativeVideoPreview && !this.isMobileDevice;
    },
    shouldAutoplayPreview() {
      return this.useNativeControls;
    },
    shouldPrimeMobilePreview() {
      if (!this.useNativeVideoPreview) {
        return false;
      }
      if (!this.isPopUp) {
        return true;
      }
      return this.isMobileDevice;
    },
    isFullPageNativePreview() {
      return !this.isPopUp && this.useNativeVideoPreview;
    },
    nativePreviewPreload() {
      if (!this.shouldPrimeMobilePreview) {
        return 'none';
      }
      return this.isFullPageNativePreview ? 'auto' : 'metadata';
    },
    galleryPlayerClass() {
      return {
        'product-player-video--with-controls': this.showNativeVideoControls,
        'product-player-video--mobile-splash': this.showMobileSplash,
        'product-player-video--full-page-splash': this.isFullPageNativePreview,
      };
    },
  },
  watch: {
    'element.id'(id, oldId) {
      if (!id || !oldId || id === oldId) {
        return;
      }
      this.nativePreviewPlaying = false;
      this.fullPageSplashDismissed = false;
      this.restartPreviewForElementChange();
    },
  },
  mounted() {
    this.initVideoPlayer();
  },
  beforeDestroy() {
    this.unbindNativePreviewVideoEvents();
    if (this.useNativeVideoPreview) {
      this.$videoPlayer.shutdown();
    } else {
      this.unloadVideoPlayer();
    }
  },
  methods: {
    unloadVideoPlayer() {
      this.$videoPlayer.unload();
    },
    initVideoPlayer() {
      this.$videoPlayer.init(this.$refs.videoPlayer, this.element, {
        autoplay: this.shouldAutoplayPreview,
        controls: this.useNativeControls,
        preload: this.nativePreviewPreload,
        preferThumbnailSource: false,
      });
      this.$nextTick(() => this.bindNativePreviewVideoEvents());
    },
    bindNativePreviewVideoEvents() {
      this.unbindNativePreviewVideoEvents();
      const video = this.$refs.videoPlayer?.querySelector?.('video');
      if (!video) {
        return;
      }
      this.nativePreviewVideoEl = video;
      video.addEventListener('playing', this.onNativePreviewPlaying);
      video.addEventListener('pause', this.onNativePreviewPause);
    },
    unbindNativePreviewVideoEvents() {
      const video = this.nativePreviewVideoEl;
      if (!video) {
        return;
      }
      video.removeEventListener('playing', this.onNativePreviewPlaying);
      video.removeEventListener('pause', this.onNativePreviewPause);
      this.nativePreviewVideoEl = null;
    },
    onNativePreviewPlaying() {
      this.nativePreviewPlaying = true;
      if (this.isFullPageNativePreview) {
        this.fullPageSplashDismissed = true;
      }
      this.syncNativePreviewControls();
    },
    onNativePreviewPause() {
      const video = this.nativePreviewVideoEl;
      if (video && !video.paused) {
        return;
      }
      this.nativePreviewPlaying = false;
      this.syncNativePreviewControls();
      if (this.isFullPageNativePreview) {
        return;
      }
      if (this.shouldPrimeMobilePreview) {
        this.$videoPlayer.unload();
      }
    },
    syncNativePreviewControls() {
      if (!this.isFullPageNativePreview) {
        return;
      }
      this.$videoPlayer.setControls(this.showNativeVideoControls);
    },
    playMobilePreview() {
      this.$videoPlayer.play();
    },
    restartPreviewForElementChange() {
      if (this.useNativeVideoPreview) {
        this.$videoPlayer.shutdown();
      } else {
        this.unloadVideoPlayer();
      }
      this.initVideoPlayer();
      if (this.shouldAutoplayPreview) {
        this.$videoPlayer.play();
      }
    },
  },
};
